import { render } from "./NaoAutorizado.vue?vue&type=template&id=0f211aab&scoped=true"
import script from "./NaoAutorizado.vue?vue&type=script&lang=js"
export * from "./NaoAutorizado.vue?vue&type=script&lang=js"

import "./NaoAutorizado.vue?vue&type=style&index=0&id=0f211aab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f211aab"]])

export default __exports__